export const PREVIEW_BULK_SCHEDULE_AUTOMATIONS = gql`
  query PREVIEW_BULK_SCHEDULE_AUTOMATIONS(
    $ruleIds: [String!]!
    $targeting: BulkScheduleTargetingInput!
  ) {
    previewBulkScheduleAutomations(ruleIds: $ruleIds, targeting: $targeting) {
      perRule {
        automatedRuleId
        supported
        eligible
        willSchedule
        pastWindow
        alreadyScheduled
        alreadyCompleted
      }
      aggregate {
        eligible
        willSchedule
        pastWindow
        alreadyScheduled
        alreadyCompleted
      }
      cap
      overCap
    }
  }
`

export const SCHEDULE_BULK_AUTOMATIONS = gql`
  mutation SCHEDULE_BULK_AUTOMATIONS(
    $ruleIds: [String!]!
    $targeting: BulkScheduleTargetingInput!
  ) {
    scheduleBulkAutomations(ruleIds: $ruleIds, targeting: $targeting) {
      perRule {
        automatedRuleId
        supported
        eligible
        willSchedule
        pastWindow
        alreadyScheduled
        alreadyCompleted
      }
      aggregate {
        eligible
        willSchedule
        pastWindow
        alreadyScheduled
        alreadyCompleted
      }
      cap
      overCap
    }
  }
`
